import { render } from "./openorders.vue?vue&type=template&id=12e7550d"
import script from "./openorders.vue?vue&type=script&lang=js"
export * from "./openorders.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tommygrimm/IdeaProjects/eurogate/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__